// extracted by mini-css-extract-plugin
module.exports = {"styles-carousel":"Carousel_styles-carousel__UOrU4"};